
import { SelectionChangedEvent } from "ag-grid-community";
import { ChargeConstantCollection } from "constants/charge/ChargeConstantCollection";
import { ManualSystemChargeEntity } from "domain/entity/ChargeDataEnquiry/ManualSystemChargeEntity";
import { E_Custom_Dispatch_Event, E_Type_Of_Event, customDispatchEvent } from "helpers/Events";
import _ from "lodash";
import { INITIAL_CHARGE_DATA_ENQUIRY_COL_DEF, transferRowData } from "presentation/constant/ChargeDataEnquiry/ContainerColumnDefinition";
import { useChargeDataSearchVM } from "presentation/hook/ChargeDataEnquiry/useChargeDataSearchVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useChargeDataSearchTracked } from "presentation/store/ChargeDataEnquiry/ChargeDataSearchProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { useCallback, useEffect, useRef, useState } from "react";
import { IconButton } from "veronica-ui-component/dist/component/core";


export const ChargeDataSearchTablePanel = () => {
    const [chargeDataSearchState] = useChargeDataSearchTracked();
    const isShowRightCriteriaPanel = chargeDataSearchState.isShowRightCriteriaPanel;
    const chargeDataSearchVM = useChargeDataSearchVM();
    const [anaInfoState] = useANAInfoTracked();
    const gridRef = useRef<any>(null);
    const [showOverlay, setShowOverlay] = useState<boolean>(false);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        chargeDataSearchVM.updateSelectedRows(selectedRows);
    }, [chargeDataSearchVM])



    const tableDoubleClicked = (data: any) => {
        if (data) {
            if (ChargeConstantCollection.systemManualInd.System === (data.data as ManualSystemChargeEntity).manualSysInd) {
                if ((data.data as ManualSystemChargeEntity).transferInd === 'Y') {
                    customDispatchEvent(E_Type_Of_Event.CHARGE_DETAIL_REDIRECT_EVENT,
                        E_Custom_Dispatch_Event.REDIRECT_TOC_CHARGE_DETAIL_FROM_CHARGE_ITEM_SEARCH,
                        {
                            userName: anaInfoState.userName,
                            data: data.data,
                        });
                } else {
                    customDispatchEvent(E_Type_Of_Event.CHARGE_DETAIL_REDIRECT_EVENT,
                        E_Custom_Dispatch_Event.REDIRECT_CHARGE_DETAIL_FROM_CHARGE_ITEM_SEARCH,
                        {
                            userName: anaInfoState.userName,
                            data: data.data,
                        });
                }
            } else if (ChargeConstantCollection.systemManualInd.Manual === (data.data as ManualSystemChargeEntity).manualSysInd) {
                customDispatchEvent(E_Type_Of_Event.CHARGE_DETAIL_REDIRECT_EVENT,
                    E_Custom_Dispatch_Event.REDIRECT_MANUAL_CHARGE_DETAIL_FROM_CHARGE_ITEM_SEARCH,
                    {
                        userName: anaInfoState.userName,
                        data: data.data,
                    });
            }
        }
    }

    useEffect(() => {
        setShowOverlay(chargeDataSearchState.isSearchLoading || (!chargeDataSearchState.isSearchLoading &&
            chargeDataSearchState.sysManuCharges && chargeDataSearchState.sysManuCharges.length) ? false : true);
    }, [chargeDataSearchState.isSearchLoading, chargeDataSearchState.sysManuCharges]);

    return <div className={`im-charge-data-search-table-panel`} style={{ position: 'relative' }}>
        <div className={`im-charge-data-search-table-panel-content`}>
            <NbisTable
                id='charge-data-search-table'
                columns={INITIAL_CHARGE_DATA_ENQUIRY_COL_DEF}
                // cacheBlockSize={30}
                isNewColumnSetting={true}
                isScrollHighlighted={true}
                // groupDisplayType={"groupRows"}
                // rowGroupPanelShow={"always"}
                rowSelection={"multiple"}
                selectionMode={true}
                showPaginator={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                showUploadIcon={true}
                isRowHighligted={true}
                suppressRowClickSelection={false}
                gridHeight="customHeight"
                customHeight={"calc(100% - 25px)"}
                onRowDoubleClick={tableDoubleClicked}
                handleSelectionChanged={handleSelectionChange}
                rowHeight={28}
                // rowBuffer={20}
                ref={gridRef}
                data={!_.isEmpty(chargeDataSearchState.sysManuCharges) ? transferRowData(chargeDataSearchState.sysManuCharges ?? []) : null}
                autoMarginLeft={true}
                entrypoint={'chargeDataEnquiry'}
                mustRefresh={true}
                showDefaultOverlayNoRowsTemplate={showOverlay}

                columnSettingIconList={[
                    <>
                        <IconButton fileName={isShowRightCriteriaPanel ? "Icon-angle-left" : "Icon-angle-right"} size="medium" toolTipText={isShowRightCriteriaPanel ? "Close Right Panel" : "Open Right Panel"} toolTipArrow={false} onClick={chargeDataSearchVM.onHideRightCriteriaPanel} />
                    </>
                ]}
            />
        </div>
    </div>
}